
// 媒体类型列表
export const MESSAGE_TYPE_LIST = [
  {
    label: '系统通知',
    value: 1,
    unread: 0, // 未读数量
  },
  {
    label: '平台规则',
    value: 2,
    unread: 0,
  },
  {
    label: '功能通知',
    value: 3,
    unread: 0,
  },
  {
    label: '结算通知',
    value: 4,
    unread: 0,
  },
  {
    label: '商品通知',
    value: 5,
    unread: 0,
  },
  {
    label: '活动通知',
    value: 6,
    unread: 0,
  },
  {
    label: '合作动态',
    value: 7,
    unread: 0,
  },
  {
    label: '问卷调查',
    value: 8,
    unread: 0,
  },
];

